import { render, staticRenderFns } from "./create-morble.vue?vue&type=template&id=6fb4acf4&"
import script from "./create-morble.vue?vue&type=script&lang=js&"
export * from "./create-morble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports